
<template>
    <!-- <div class="headtop">
      <div class="center3">
        <div
          class="rightTop"
          v-for="item in inType"
          :key="item.id"
          @click="routLinkTo(item.route)"
        >
          <div>
            <i :class="item.img"></i>
            <span>{{ item.des }}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div style="margin: 20px 0;"></div>
</template>
<script>
export default {
  name: 'headerTop',
  components: {},
  data () {
    return {

      inType: [
        {
          value: 0,
          img: 'el-icon-picture-outline-round',
          des: '首页',
          route: '/indexpage/index'
        },
        {
          value: 1,
          img: 'el-icon-attract',
          des: '全部商品',
          route: '/indexpage/productlist'
        },
        {
          value: 2,
          des: '我要询价',
          img: 'el-icon-c-scale-to-original',
          route: '/addInventory'
        },
        {
          value: 3,
          des: '快速下单',
          img: 'el-icon-thumb',
          route: '/quickly'
        }
      ],

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    routLinkTo (val) {
      if (val === '/quickly') {
        this.$router.push(val)
      //   const { href } = this.$router.resolve({
      //   path: "/quickly",

      // });
      // window.open(href, "_blank");
      }else{
        this.$router.push(val)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
      .headtop {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  // max-width: 1280px;
  // margin: 20px auto 30px auto;
  background: #409EFF;
  display: flex;
}

.center3 {
  width: 1480px;
  margin: 0 auto;
  display: flex;
}

.rightTop {
margin-left: 10px;
  cursor: pointer;
  color: #fff;
  width: 120px;
  font-size: 16px;
  text-align: center;
}

.rightTop:hover {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/base/headerTop.vue